import { useTranslations } from '@rematter/modules/transportation/i18n/useTranslations';
import { NumberField, TextField } from '@rematter/ui-web';
import { useAtomValue, useSetAtom } from 'jotai';

import {
  $assetTypeForm,
  $updateAssetTypeForm,
} from '~/modules/transportation/state/assetTypeForm.localState';

type AssetTypeFormProps = {
  isEditing?: boolean;
};

export const AssetTypeForm = (_props: AssetTypeFormProps) => {
  const t = useTranslations();
  const form = useAtomValue($assetTypeForm);
  const updateForm = useSetAtom($updateAssetTypeForm);

  const handleFieldChange =
    <K extends keyof typeof form>(field: K) =>
    (value: (typeof form)[K]) => {
      updateForm({
        [field]: value,
      });
    };

  return (
    <div className="@AssetTypeForm flex flex-col gap-4">
      <TextField
        label={t.assetTypesView.form.fields.name}
        value={form.name}
        onChange={handleFieldChange('name')}
        isRequired
      />

      <TextField
        label={t.assetTypesView.form.fields.description}
        value={form.description}
        onChange={handleFieldChange('description')}
      />

      <NumberField
        label={t.assetTypesView.form.fields.capacity}
        value={form.capacity}
        onChange={handleFieldChange('capacity')}
        isRequired
      />
    </div>
  );
};
